import styled from "styled-components";
import { ConfirmDialog } from "primereact/confirmdialog";
import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue800} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }
`;

export const CardWrapper = styled.div`
  margin: 15px;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  padding: 20px;
  align-items: start;
  justify-content: space-between;
  background-color: ${theme.colors.darkBlue};
  gap: 20px;

  .button-create {
    margin-top: 1rem;
    max-width: 12rem;
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    padding: 12px 24px;
    border-radius: 100px;
    text-decoration: none;
    font-family: ${theme.font.poppins};
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    
    &:hover {
      opacity: 0.8;
    }
  }

  @media screen and (max-width: 768px) {
    gap: 15px;
    
    .button-create {
      align-self: stretch;
      justify-content: center;
    }
  }
`;

export const ContainerFilter = styled.div`
  flex: 1;

  form {
    margin: 0;
    padding: 0;
  }
`;

export const ConfirmDialogStyled = styled(ConfirmDialog)`
  .p-dialog-header {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-content {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-footer {
    background: ${theme.colors.darkBlue};
    font-family: ${theme.font.poppins};
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;
